import { createContext, useContext, useEffect, useState } from "react"

type PageContextType = {
  theme?: string | null
  setTheme?: (theme: string) => void
  featuredImage?: string | null
  setFeaturedImage?: (image: string) => void
}

export const PageContext = createContext<PageContextType | undefined>(undefined)

export const PageProvider = ({ theme: th, children }: { theme?: string | null; children: React.ReactNode }) => {
  const [theme, setTheme] = useState<string | null>(th || null)
  const [featuredImage, setFeaturedImage] = useState<string | null>(null)

  useEffect(() => {
    if (th) {
      setTheme(th)
    }
  }, [th])

  return (
    <PageContext.Provider value={{ theme, setTheme, featuredImage, setFeaturedImage }}>{children}</PageContext.Provider>
  )
}

export const usePageContext = () => {
  const context = useContext(PageContext)
  // if (context === undefined && !env.admin) {
  //   throw new Error("usePageContext must be used within a PageProvider")
  // }
  return context || { theme: "yellow" }
}
